import { UserType } from "../../../types/userType";

interface props {
  isSmall: boolean;
  data: UserType;
  activeStatus: boolean;
}

const Avatar = ({ isSmall, data, activeStatus }: props) => {
  return (
    <div
      className={`${
        isSmall ? "h-[16px] w-[16px] text-[10px]" : "h-[42px] w-[42px] text-xl"
      } rounded-full bg-violet-500 relative border-2 border-white flex justify-center items-center font-light text-white`}
    >
      {data.avatar ? (
        <img
          src={data.avatar}
          alt={data.name}
          className="object-cover object-center h-full w-full rounded-full"
        />
      ) : (
        <p>{data.name.split("")[0]}</p>
      )}
      {!isSmall && activeStatus && (
        <div className="h-3 w-3 rounded-full bg-green-400 bottom-0 right-0 absolute border-2 border-white"></div>
      )}
    </div>
  );
};

export default Avatar;
